import i18n from "i18next";

export function formatNumber(
	num: number,
	{ minDigits, maxDigits }: { minDigits?: number; maxDigits?: number } = {
		maxDigits: 2,
	},
): string {
	return num.toLocaleString(i18n.language, {
		minimumFractionDigits: minDigits,
		maximumFractionDigits: maxDigits,
	});
}

export function formatMoneyWithCurrency(amount: number, currencyCode: string | null | undefined): string {
	const currencySymbolOrCode = getCurrencySymbolOrCode(currencyCode);
	const formattedAmount = formatNumber(amount, { minDigits: 2, maxDigits: 2 });
	return currencySymbolOrCode === "" ? formattedAmount : `${formattedAmount} ${currencySymbolOrCode}`;
}

export function getCurrencySymbolOrCode(currencyCode: string | null | undefined): string {
	const trimmedCurrencyCode = currencyCode?.trim();
	if (trimmedCurrencyCode == null || trimmedCurrencyCode === "") return "";
	if (trimmedCurrencyCode.toUpperCase() === "EUR") return "€";
	return trimmedCurrencyCode;
}

/**
 * @deprecated Use formatMoneyWithCurrency with an explicit currency code instead.
 */
export function formatMoney(amount: number): string {
	return formatMoneyWithCurrency(amount, "EUR");
}

export function round(amount: number, decimals: number): number {
	return Math.round(amount * 10 ** decimals) / 10 ** decimals;
}
